
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary/[cName]/categories",
      function () {
        return require("private-next-pages/dispensary/[cName]/categories.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary/[cName]/categories"])
      });
    }
  